import Proxy from './Proxy';

class AdvertiserProxy extends Proxy {

  constructor(parameters = {}) {
    super('api/advertiser/management', parameters);
  }

  /**
   * 광고주 현황 (층별)
   * @param companySeq
   * @returns {Promise}
   */
  getAdvertiserStatus(params) {
    return this.submit('post', `${this.endpoint}/status`, params);
  }

  /**
   * 광고주 현황 (광고)
   * @param companySeq
   * @returns {Promise}
   */
  getAdvertiserMediaList(params) {
    return this.submit('post', `${this.endpoint}/medias`, params);
  }

  /**
   * 광고 상세
   * @param advertisementSeq
   * @returns {Promise}
   */
  getAdvertiserMediaDetail(advertisementSeq) {
    return this.submit('get', `${this.endpoint}/medias/${advertisementSeq}`);
  }

}

export default AdvertiserProxy;
